// extracted by mini-css-extract-plugin
module.exports = {"userIcon":"Nav_userIcon__3ZkD2","navbarCustom":"Nav_navbarCustom__1Icve","brand":"Nav_brand__vsnbc"};